export default __webpack_public_path__ + "01b23eff0b506b257bedc030b4adb9c1.png";